/**
 * AudioWaveform Component
 * Visualizes audio recording/playback
 */

import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import './AudioWaveform.css';

interface AudioWaveformProps {
  isActive?: boolean;
  barCount?: number;
  className?: string;
}

export const AudioWaveform: React.FC<AudioWaveformProps> = ({
  isActive = false,
  barCount = 5,
  className,
}) => {
  const [heights, setHeights] = useState<number[]>([]);

  useEffect(() => {
    if (isActive) {
      // Animate bars randomly
      const interval = setInterval(() => {
        setHeights(Array.from({ length: barCount }, () => Math.random() * 100));
      }, 150);

      return () => clearInterval(interval);
    } else {
      setHeights(Array.from({ length: barCount }, () => 20));
    }
  }, [isActive, barCount]);

  return (
    <div className={clsx('ai360-audio-waveform', className)}>
      {Array.from({ length: barCount }).map((_, i) => (
        <div
          key={i}
          className="ai360-audio-waveform-bar"
          style={{
            height: isActive ? `${heights[i] || 20}%` : '20%',
            animationDelay: `${i * 0.1}s`,
          }}
        />
      ))}
    </div>
  );
};
